// for usage in event.key
export enum Key {
	Enter = 'Enter',
	Tab = 'Tab',
	Shift = 'Shift',
	Delete = 'Delete',
	Up = 'ArrowUp',
	Down = 'ArrowDown',
	Left = 'ArrowLeft',
	Right = 'ArrowRight',
}